const BOOLEAN_TEXT = {
  YES: 'Yes',
  NO: 'No',
};

Object.freeze(BOOLEAN_TEXT);

export { BOOLEAN_TEXT };
